import { render, staticRenderFns } from "./ServiceAreasBlockoutDay.vue?vue&type=template&id=ff1f3cf4&scoped=true&"
import script from "./ServiceAreasBlockoutDay.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasBlockoutDay.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasBlockoutDay.vue?vue&type=style&index=0&id=ff1f3cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1f3cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1f3cf4')) {
      api.createRecord('ff1f3cf4', component.options)
    } else {
      api.reload('ff1f3cf4', component.options)
    }
    module.hot.accept("./ServiceAreasBlockoutDay.vue?vue&type=template&id=ff1f3cf4&scoped=true&", function () {
      api.rerender('ff1f3cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/BlockoutDays/ServiceAreasBlockoutDay.vue"
export default component.exports